import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state'

export const OFFER_VERSIONS_MINIMAL_QUERY = gql`
query revisionsForOffer($expressions: ExpressionsInput!) {
  quotes {
    groupedRevisions(
      expressions: $expressions
    ) {
      items {
        title
        documentId
        revisions {
          title
          dealerOfferTitle: customProperty(key: "DealerOfferTitle") { stringValue }
          manufacturerOfferTitle: customProperty(key: "ManufacturerOfferTitle") { stringValue }
          revision
          locked
          status
          ...QuotePricingStateFragment
        }
      }
    }
  }
}
${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class OfferVersionsMinimalQuery extends Query<RootQuery> {
  document = OFFER_VERSIONS_MINIMAL_QUERY;
}
